import React from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import HeroSection from "./hero-section/HeroSection";
import ToppersHighlights from "../section-component/topper-highlight/ToppersHighlights";
import Testimonials from "../section-component/testimonial-section/Testimonials";
import FreeResources from "../section-component/free-resources/FreeResources";
import CallToAction from "../section-component/call-to-action/CallToAction";
import CtaButton from "../../../components/cta-button/CtaButton";
import EnquirePopup from "../../../components/enquire-form/EnquirePopup";
import LiveChat from "../section-component/live-chat/LiveChat";
import KeyAchievements from "../section-component/key-achievement/KeyAchievements";
import WhyChooseUs from "./why-choose-us/WhyChooseUs";
import SuccessStories from "./success-stories/SuccessStories";
import UpcomingBatches from "./upcoming-batches/UpcomingBatches";
import VideoTour from "./video-tour/VideoTour";
import BlogPreview from "./blog-preview/BlogPreview";
import CallToActionBanner from "./call-to-action-banner/CallToActionBanner";
import HomeCourseOverview from "./home-course-overview/HomeCourseOverview";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const HomeIndex = () => {
    return (
        <>
            
             
            <EnquirePopup />
            <HeroSection />
            {/* <KeyAchievements /> */}
            {/* <CtaButton /> */}
            <HomeCourseOverview />
            <WhyChooseUs />
            {/* <SuccessStories /> */}
            <UpcomingBatches />
            {/* <VideoTour /> */}
            <BlogPreview />
            <CallToActionBanner />

            
        </>
    );
};

export default HomeIndex;